import * as React from "react";
const SvgFiRrPigFace = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pig-face_svg__a)">
      <path
        fill="#062147"
        d="M8.5 12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m15.52-9.087c-.256 1.625-1.014 3.643-2.043 5.46A10.9 10.9 0 0 1 23 13c0 6.065-4.935 11-11 11s-11-4.936-11-11c0-1.654.367-3.222 1.023-4.63C.648 5.936.196 3.758.062 2.913A2.5 2.5 0 0 1 .649.878 2.57 2.57 0 0 1 2.62.013C4.873.064 7.396.3 9.175 2.37a10.982 10.982 0 0 1 5.651.001C16.608.302 19.172.064 21.463.013a2.53 2.53 0 0 1 1.97.864c.489.56.703 1.301.588 2.036M2.039 2.601c.186 1.176.615 2.511 1.199 3.758a11.1 11.1 0 0 1 3.882-3.215C6.045 2.275 4.61 2.058 2.576 2.011c-.274.01-.36.112-.421.182a.5.5 0 0 0-.117.407zM21 13.001c0-4.963-4.037-9-9-9s-9 4.037-9 9c0 4.961 4.037 9 9 9s9-4.039 9-9m.928-10.808a.53.53 0 0 0-.406-.182h-.014c-2.03.046-3.524.27-4.62 1.136a11.1 11.1 0 0 1 3.883 3.221c.73-1.504 1.134-2.876 1.275-3.768a.5.5 0 0 0-.118-.408zM16 15.5c0 1.93-1.794 3.5-4 3.5s-4-1.57-4-3.5S9.794 12 12 12s4 1.57 4 3.5m-2 0c0-.813-.916-1.5-2-1.5s-2 .687-2 1.5.916 1.5 2 1.5 2-.687 2-1.5M15.5 9a1.5 1.5 0 1 0 0 3.001 1.5 1.5 0 0 0 0-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pig-face_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPigFace;
